import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Col from 'react-bootstrap/lib/Col';
import queryString from 'query-string';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

// Components.
import Header from 'components/Header';
import Footer from 'components/Footer';
import IntercomChat from 'components/IntercomChat';
import LoaderSpinnerPage from 'components/LoaderSpinnerPage';
import DashboardSharedInfo from 'components/DashboardSharedInfo';

// Actions.
import * as AuthActions from 'actions/AuthActions';
import * as AnalyticsActions from 'actions/AnalyticsActions';
import * as PayConnectedPackagesActions from 'actions/PayConnectedPackagesActions';

// Utils.
import { isWebviewApp, isMobile } from 'utils';

// Styles.
import styles from './styles.module.scss';

// Images.
import { ReactComponent as WarningIcon } from './images/warningIcon.svg';

import { baseURL } from 'config/index'


@withRouter
@connect(
  state => ({
    auth: state.auth,
    profile: state.profile,
    config: state.config,
    i18n: state.i18n,
    payConnectedPackages: state.payConnectedPackages,
    consents: state.consents,
  }),
  dispatch => ({
    authActions: bindActionCreators(AuthActions, dispatch),
    payConnectedPackagesActions: bindActionCreators(PayConnectedPackagesActions, dispatch),
  })
)
export default class AuthContainer extends Component {

  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    consents: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    additionTitle: PropTypes.element,
    content: PropTypes.element,
    children: PropTypes.element,
  };

  componentDidMount() {
    if (this.props.location) {
      const query = queryString.parse(this.props.location.search);
      if (query.token !== undefined) {
        this.props.authActions.loginToken(query.token);
      }
      if (query.scope !== undefined && query.scope === 'ifttt') {
        const search = queryString.stringify(query);
        window.location.replace(`${baseURL}/oauth2/authorize/?${search}`);
      }
    }

    if (this.props.payConnectedPackages.isFetched === false) {
      this.props.payConnectedPackagesActions.loadPayConnectedPackages();
    }
  }

  onClickTryWelltoryButton = () => {
    this.props.authActions.logoutToken();
  };

  onClickAnaliticsGetAppButton = () => {
    AnalyticsActions.clickGetAppButton();
  };

  render() {
    const {
      auth,
      profile: { isFetched: isFetchedProfile, isUpdated: isUpdatedProfile, profile },
      consents: { isFetched: isFetchedConsents, consents },
      config: { isFetched: isFetchedConfig, config },
      location,
      i18n,
      content,
      children,
      title,
      additionTitle,
      payConnectedPackages,
      width,
      theme,
    } = this.props;
    if (auth.isAuthenticated) {
      if (!isUpdatedProfile && !isFetchedProfile) {
        return <LoaderSpinnerPage />;
      }
    }

    const isWebviewAppStatus = isWebviewApp();
    return (
      <div className={cx(styles.authWrapper, { [styles.isWebView]: isWebviewAppStatus })} style={{ width: width }}>
        {!isWebviewAppStatus &&
          <Header
            isFetchedProfile={isFetchedProfile}
            auth={auth}
            profile={profile}
            locationPath={location.pathname}
            payConnectedPackages={payConnectedPackages}
            width={width}
            theme={theme}
            onClickAnaliticsGetAppButton={this.onClickAnaliticsGetAppButton}
          />
        }
        <div id="content" className={styles.content}>
          <div className="container-fixed" style={{ width: width }}>
            {(isFetchedProfile && profile.billing_status === 'failed') &&
              <div className={styles.paymentMessageOldProduct}>
                <WarningIcon />
                {I18n.t('Failed payment Please double-check your payment info')}
              </div>
            }
            <DashboardSharedInfo
              auth={auth}
              profile={profile}
              locale={i18n.locale}
              onClickTryWelltoryButton={this.onClickTryWelltoryButton}
            />
            <Grid container className={styles.container}>
              <div className={cx(styles.titleWrapper, { [styles.isEmptyTitle]: !(title || additionTitle) })}>
                {title &&
                  <Col xs={12} md={6} className={styles.title}>
                    {title}
                  </Col>
                }
                {additionTitle &&
                  <Col xs={12} md={6} className={styles.additionTitle}>
                    {additionTitle}
                  </Col>
                }
              </div>
              <div className={cx(styles.contentWrapper, { [styles.isWebView]: isWebviewAppStatus })}>
                <Col xs={12} md={12}>
                  {content || children}
                </Col>
              </div>
            </Grid>
          </div>
        </div>
        {!isWebviewAppStatus &&
          <Footer locationPath={location.pathname} />
        }
        <IntercomChat
          auth={auth}
          isFetchedProfile={isFetchedProfile}
          isFetchedConsents={isFetchedConsents}
          profile={profile}
          consents={consents}
          isFetchedConfig={isFetchedConfig}
          config={config}
          locationPath={location.pathname}
        />
      </div>
    );
  }

}
